var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    y: 0.125,
    width: 13.75,
    height: 9.75,
    rx: 0.875,
    fill: "#fff",
    stroke: "#F5F5F5",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("mask", {
    id: "da_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    y: 0.125,
    width: 13.75,
    height: 9.75,
    rx: 0.875,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#da_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0a1 1 0 00-1 1v3h4V0H1zm5 0v4h8V1a1 1 0 00-1-1H6zm8 6H6v4h7a1 1 0 001-1V6zM4 10V6H0v3a1 1 0 001 1h3z",
    fill: "#EF264D"
  }))));
}
export default SvgDa;